






























import { News } from '@/models/dashboard';
import { typedStore, Actions } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'DeleteNewsModal',
  props: {
    news: Object as () => News,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    modalContentText(): string {
      return this.$t(
        'admin-panel.news.delete-modal.content',
        {
          title: this.news?.title,
        },
      ) as string;
    },
  },
  methods: {
    async deleteNews() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.news.deleteNews,
          {
            id: this.news.id,
          },
        );
        this.$bvModal.hide('delete-news-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
